import React, { useState } from 'react';

import { useDispatch } from 'react-redux';
import { DEFAULT_PAGINATION, SORTING_TYPE } from '../../../../../constants';
import { CButton, CSpinner } from '@coreui/react-pro';
import ResultReports from '../ResultReports';
import { exportOrganizationTrainingReports, getOrganizationTrainingReports } from '../actions';
import OrganizationSelect from './OrganizationSelect';
import UpcomingSelect from './UpcomingSelect';
import TrainingDateSelect from './TrainingDateSelect';
import ProductSelect from './ProductSelect';

const FilterReport = () => {
     const dispatch = useDispatch();

     const [filterOptions, setFilterOptions] = useState({});
     const [eventProductId, setEventProductId] = useState();
     const [isTrainingDate, setIsTrainingDate] = useState(false);
     const [isUpcoming, setIsUpcoming] = useState(false);
     const [isLoadingFilter, setIsLoadingFilter] = useState(false);
     const [isLoadingExcel, setIsLoadingExcel] = useState(false);
     const [reportPreview, setReportPreview] = useState();
     const [isEmptyExcel, setIsEmptyExcel] = useState(false);

     const [pagination, setPagination] = useState({
          page: DEFAULT_PAGINATION.PAGE,
          pageSize: DEFAULT_PAGINATION.PAGE_SIZE,
          sortBy: 'organizationName',
          sortType: SORTING_TYPE.DESC,
          filter: filterOptions,
     });

     const isDisableFilter = isLoadingFilter || isLoadingExcel;

     const handleFilterReport = () => {
          const paginationPayload = {
               page: DEFAULT_PAGINATION.PAGE,
               pageSize: pagination.pageSize,
               filter: filterOptions,
          };
          const updatedPagination = { ...pagination, ...paginationPayload };
          setPagination(updatedPagination);

          const nextDispatch = {
               paginationPayload,
               setIsLoadingFilter,
               setReportPreview,
          };
          dispatch(getOrganizationTrainingReports(nextDispatch));
     };

     const handleExcelReport = () => {
          const nextDispatch = {
               pagination,
               setIsLoadingExcel,
               setIsEmptyExcel,
          };
          dispatch(exportOrganizationTrainingReports(nextDispatch));
     };

     return (
          <>
               <div className="survey-reports-filters">
                    <div className="row w-100">
                         <div className="col-md-3">
                              <label className="form-label" htmlFor="product">
                                   Organization
                              </label>

                              <OrganizationSelect filterOptions={filterOptions} setFilterOptions={setFilterOptions} />
                         </div>
                         <div className="col-md-3">
                              <label className="form-label" htmlFor="product">
                                   Product
                              </label>

                              <ProductSelect filterOptions={filterOptions} setFilterOptions={setFilterOptions} eventProductId={eventProductId} />
                         </div>
                         <div className="col-md-3">
                              <label className="form-label" htmlFor="order-date">
                                   Upcoming Training Event
                              </label>
                              <UpcomingSelect
                                   filterOptions={filterOptions}
                                   setFilterOptions={setFilterOptions}
                                   eventProductId={eventProductId}
                                   setEventProductId={setEventProductId}
                                   isTrainingDate={isTrainingDate}
                                   setIsUpcoming={setIsUpcoming}
                              />
                         </div>
                         <div className="col-md-3">
                              <label className="form-label" htmlFor="order-date">
                                   Training Date
                              </label>
                              <TrainingDateSelect
                                   filterOptions={filterOptions}
                                   setFilterOptions={setFilterOptions}
                                   eventProductId={eventProductId}
                                   setEventProductId={setEventProductId}
                                   isUpcoming={isUpcoming}
                                   setIsTrainingDate={setIsTrainingDate}
                              />
                         </div>
                    </div>
               </div>
               <div className="d-flex align-items-start survey-reports-filters">
                    <CButton disabled={isDisableFilter} onClick={handleFilterReport}>
                         Filter
                    </CButton>
                    <div className="d-flex align-items-center">
                         <CButton className="me-3" disabled={isDisableFilter || !reportPreview} onClick={handleExcelReport}>
                              Export Excel
                         </CButton>

                         {isLoadingExcel && <CSpinner color="primary" />}
                         {isEmptyExcel && <span>No data to download the file.</span>}
                    </div>
               </div>

               {isLoadingFilter ? (
                    <div className="text-center">
                         <CSpinner color="primary" />
                    </div>
               ) : (
                    <>
                         {reportPreview && (
                              <ResultReports
                                   reportPreview={reportPreview}
                                   setReportPreview={setReportPreview}
                                   filterOptions={filterOptions}
                                   pagination={pagination}
                                   setPagination={setPagination}
                              />
                         )}
                    </>
               )}
          </>
     );
};

export default FilterReport;
